import { landingType, rfLandingType, campaignType, marketingScene } from 'Src/const/state/campaign.js'
import Tool from 'Src/util/tool'
import { Splash } from 'Src/const/state/creative.js'
import json from 'Src/util/json.js'
import { checkIsSupportLive } from 'Src/util/fetch.js'
import * as creativeState from 'Src/const/state/creative'
import LegalText from 'Src/const/cross-end-delivery-words/index'
import { automateRule } from '@ad/reporter_config_package'
const { conditionConfig, automateRuleConfig } = automateRule

const IMAGEMODE = creativeState.imageMode

const isSearchAdv = json.catchableParse(GLOBAL_VAR.adv_search_tag)
// 广告主支持投放管家
const isDeliveryMajordomo = Tool.isSupported(GLOBAL_VAR.adver_func.delivery_majordomo)

// 两阶段出价
export const isTwoStageWhiteList = Tool.isSupported(GLOBAL_VAR?.adver_func?.SearchAdDeliveryPhrase)

// 332 新竞价策略（合并原有常规投放 & 放量投放 为 稳定成本 ）
export const isNewBiddingStrategy = Tool.isSupported(GLOBAL_VAR?.adver_func?.another_new_bid_strategy)
// 333 no bid
export const isSupportNoBid = Tool.isSupported(GLOBAL_VAR?.adver_func?.nobid)

// 是否启用可以启用新竞价策略
export const isSupportNewBiddingStrategy = isNewBiddingStrategy || isSupportNoBid

export const filtersNav = [
  {
    label: $bp_t('组', 'common.group'),
    id: 'campaign'
  },
  {
    label: $bp_t('计划', 'common.plan'),
    id: 'ad'
  },
  {
    label: $bp_t('创意', 'common.originality'),
    id: 'creative'
  }
]

export const NoLimitVal = 'no-limit'

export const PromotionFilterValue = {
  AdStatus: {
    _key: 'filter_ad_status',
    noLimit: 0, // 投放中
    delivering: 13, // 投放中
    auditReject: 16, // 审核拒绝
    noBudget: 11 // 预算不足计划
  },
  AppCode: {
    _key: 'app_code'
  },
  ImageMode: {
    _key: 'image_mode'
  },
  PurchaseType: {
    rf: 1 // 购买类型是合约
  }
}

// API Doc: https://yapi.bytedance.net/project/1136/interface/api/1021123
// API Doc： https://wiki.bytedance.net/pages/viewpage.action?title=20190318-20190325&spaceKey=ADRD#id-20190318-20190325-ad.status%EF%BC%9A
export const filters = {
  campaign: {
    normal: [
      {
        key: 'campaign_status',
        name: $bp_t('组状态', 'bp.promotion_group_state'),
        multiple: false,
        selected: [],
        options: [
          {
            label: $bp_t('不限', 'common.unlimited'),
            value: 1
          },
          {
            label: $bp_t('启用', 'common.enable'),
            value: 2
          },
          {
            label: $bp_t('暂停', 'common.suspend'),
            value: 3
          },
          {
            label: $bp_t('删除', 'common.delete'),
            value: 4
          },
          {
            label: $bp_t('不限（包含已删除）', 'common.unlimited_including_deleted'),
            value: NoLimitVal
          }
        ]
      },
      {
        key: 'purchase_type',
        name: $bp_t('购买类型', ''),
        multiple: false,
        selected: [0],
        defaultSelected: [0],
        isMutuallyExclusive: true, // 是否互斥枚举类型
        options: [
          {
            label: $bp_t('竞价', ''),
            value: 0
          },
          {
            label: $bp_t('合约', ''),
            value: 1
          }
        ]
      },
      {
        key: 'landing_type',
        name: $bp_t('推广目的', 'common.landing_type'),
        multiple: true,
        selected: [],
        options: [
          {
            // label: '销售线索收集',
            label: landingType.EXTERNAL.text,
            value: 1
          },
          {
            // label: '头条文章推广',
            label: landingType.ARTICLE.text,
            value: 2
          },
          {
            // label: '应用推广',
            label: landingType.DOWNLOAD.text,
            value: 3
          },
          {
            // label: '商品推广',
            label: landingType.GOODS.text,
            value: 4
          },
          {
            // label: '商品目录推广',
            label: landingType.PRODUCT_LIBRARY.text,
            value: 5
          },
          {
            // label: '门店推广',
            label: landingType.ADVERTISER_STORE.text,
            value: 6
          },
          {
            // label: '抖音号推广',
            label: landingType.AWEME_POPULARIZE.text,
            value: 7
          },
          {
            // label: '电商店铺推广',
            label: landingType.SHOP.text,
            value: 8
          },
          {
            label: landingType.QUICK_APP.text,
            value: landingType.QUICK_APP.value
          },
          {
            // label: '营销页面推广',
            label: rfLandingType.MARKETING_PROMOTION.text,
            value: rfLandingType.MARKETING_PROMOTION.value
          }
        ]
      },
      {
        key: 'dedicate_type',
        name: $bp_t('iOS专属广告', 'bp.promotion_group_state'),
        multiple: false,
        selected: [],
        options: [
          {
            label: $bp_t('不限', 'common.unlimited'),
            value: NoLimitVal
          },
          {
            label: $bp_t('iOS专属广告', 'common.unlimited'),
            value: 2
          },
          {
            label: $bp_t('非iOS专属广告', 'common.enable'),
            value: 0
          }
        ]
      }
      // {
      //   key: 'campaign_type',
      //   name: '组类型',
      //   multiple: true,
      //   selected: [],
      //   options: [
      //     {
      //       label: '信息流广告',
      //       value: 1
      //     },
      //     {
      //       label: '搜索广告',
      //       value: 2
      //     }
      //   ]
      // }
    ]
    // 一期因后端性能问题，暂不支持效果指标筛选。
    // effect: [
    //   {
    //     key: 'campaign_budget_mode',
    //     name: '组预算',
    //     multiple: true,
    //     selected: [],
    //     options: [
    //       {
    //         label: '不限',
    //         value: -1
    //       },
    //       {
    //         label: '按日预算',
    //         value: 0
    //       }
    //     ]
    //   },
    //   {
    //     type: 'range',
    //     key: 'campaign_budget',
    //     name: '组总消耗',
    //     selected: {
    //       st: '',
    //       et: '',
    //       unit: ''
    //     }
    //   },
    //   {
    //     type: 'range',
    //     key: 'stat_cost',
    //     name: '消耗',
    //     selected: {
    //       st: '',
    //       et: '',
    //       unit: ''
    //     }
    //   },
    //   {
    //     type: 'range',
    //     key: 'show_cnt',
    //     name: '组展示数',
    //     selected: {
    //       st: '',
    //       et: '',
    //       unit: ''
    //     }
    //   },
    //   {
    //     type: 'range',
    //     key: 'click_cnt',
    //     name: '组点击数',
    //     selected: {
    //       st: '',
    //       et: '',
    //       unit: ''
    //     }
    //   },
    //   {
    //     type: 'range',
    //     key: 'convert_cnt',
    //     name: '转化数',
    //     selected: {
    //       st: '',
    //       et: '',
    //       unit: ''
    //     }
    //   },
    //   {
    //     type: 'range',
    //     key: 'ctr',
    //     name: '点击率',
    //     selected: {
    //       st: '',
    //       et: '',
    //       unit: ''
    //     }
    //   },
    //   {
    //     type: 'range',
    //     key: 'cpc_platform',
    //     name: '点击成本',
    //     selected: {
    //       st: '',
    //       et: '',
    //       unit: ''
    //     }
    //   },
    //   {
    //     type: 'range',
    //     key: 'conversion_cost',
    //     name: '转化成本',
    //     selected: {
    //       st: '',
    //       et: '',
    //       unit: ''
    //     }
    //   },
    //   {
    //     type: 'range',
    //     key: 'conversion_rate',
    //     name: '转化率',
    //     selected: {
    //       st: '',
    //       et: '',
    //       unit: ''
    //     }
    //   },
    //   {
    //     type: 'range',
    //     key: 'cpm_platform',
    //     name: '平均千次展现费用',
    //     selected: {
    //       st: '',
    //       et: '',
    //       unit: ''
    //     }
    //   }
    // ]
  },
  ad: {
    normal: [
      {
        key: 'ad_status',
        name: $bp_t('计划状态', 'common.ad_status'),
        multiple: false,
        selected: [],
        options: [
          {
            label: $bp_t('不限', 'common.unlimited'),
            // value: 0
            value: PromotionFilterValue.AdStatus.noLimit
          },
          {
            label: $bp_t('投放中', 'common.ad_status_0'),
            // value: 13
            value: PromotionFilterValue.AdStatus.delivering
          },
          {
            label: $bp_t('审核不通过', 'common.ad_status_41'),
            // value: 16
            value: PromotionFilterValue.AdStatus.auditReject
          },
          {
            label: $bp_t('不在投放时段', 'common.ad_status_13'),
            value: 14
          },
          {
            label: $bp_t('已暂停', 'common.ad_status_5'),
            value: 4
          },
          {
            label: $bp_t('已被广告组暂停', 'common.ad_status_6'),
            value: 5
          },
          {
            label: $bp_t('广告计划超出预算', 'common.creative_status_42'),
            // value: 11
            value: PromotionFilterValue.AdStatus.noBudget
          },
          {
            label: $bp_t('广告组超出预算', 'common.ad_status_7'),
            value: 8
          },
          // {
          //   label: '广告主超出预算',
          //   value: 7
          // },
          // {
          //   label: '广告主接近预算',
          //   value: 12
          // },
          {
            label: $bp_t('账户余额不足', 'common.ad_status_43'),
            value: 10
          },
          {
            label: $bp_t('新建审核中', 'common.ad_status_2'),
            value: 2
          },
          {
            label: $bp_t('修改审核中', 'common.ad_status_3'),
            value: 15
          },
          {
            label: $bp_t('计划新建', 'common.ad_status_21'),
            value: 17
          },
          {
            label: $bp_t('已删除', 'common.ad_status_4'),
            value: 1
          },
          {
            label: $bp_t('已完成', 'common.ad_status_12'),
            value: 3
          },
          {
            label: $bp_t('未达到投放时间', 'common.creative_status_11'),
            value: 6
          },
          // {
          //  label: '落地页暂不可用',
          //  value: 20
          // },
          // {
          //  label: '部分投放中',
          //  value: 9
          // },
          {
            label: $bp_t('不限（包含已删除）', 'common.unlimited_including_deleted'),
            value: NoLimitVal
          }
        ]
      },
      {
        key: 'pricing',
        name: $bp_t('计费方式', 'common.billing_mode'),
        multiple: true,
        selected: [],
        options: [
          {
            label: $bp_t('CPM', 'bp.promotion_cpm'),
            value: 1
          },
          {
            label: $bp_t('CPC', 'bp.promotion_cpc'),
            value: 2
          },
          {
            label: $bp_t('oCPC', 'bp.promotion_ocpc'),
            value: 7
          },
          {
            label: $bp_t('CPA', 'bp.promotion_cpa'),
            value: 8
          },
          {
            label: $bp_t('oCPM', 'bp.promotion_ocpm'),
            value: 9
          },
          {
            label: $bp_t('CPV', 'bp.promotion_cpv'),
            value: 10
          },
          {
            label: 'CPC-oCPM',
            value: 11
          }
        ]
      },
      {
        key: PromotionFilterValue.AppCode._key,
        name: LegalText.promotion.placing_position,
        multiple: true,
        selected: [],
        options: [
          {
            label: $bp_t('西瓜视频', 'common.watermelon_video'),
            value: 1
          },
          {
            label: $bp_t('抖音火山版', 'common.volcano_video'),
            value: 3
          },
          {
            label: $bp_t('抖音', 'common.dithering_short_video'),
            value: 4
          },
          {
            label: $bp_t('今日头条', 'common.today_s_headlines'),
            value: 8
          },
          {
            label: '番茄小说',
            value: 26
          },
          {
            label: $bp_t('穿山甲', 'common.pangolin'),
            value: 9
          }
          // {
          //   label: 'FaceU',
          //   value: 11
          // },
          // {
          //   label: '好好学习',
          //   value: 13
          // },
          // {
          //   label: '懂车帝',
          //   value: 14
          // },
          // {
          //   label: '皮皮虾',
          //   value: 16
          // },
          // {
          //   label: '轻颜相机',
          //   value: 17
          // },
        ]
      },
      {
        key: 'flow_control_mode',
        // yangbo 修改显示文案，需要修改多语言    由  投放方式   改为    竞价策略
        name: $bp_t('投放方式', 'common.flow_control_mode'),
        multiple: true,
        selected: [],
        options: [
          {
            label: $bp_t('优先跑量', 'common.priority_volume'),
            value: 0
          },
          {
            label: $bp_t('优先低成本', 'common.priority_low_cost'),
            value: 1
          },
          {
            label: $bp_t('均衡投放', 'common.balanced_delivery'),
            value: 3
          }
        ]
      },
      // 后端暂不支持
      // {
      //   key: 'delivery_range',
      //   name: '投放范围',
      //   multiple: true,
      //   selected: [],
      //   options: [
      //     {
      //       label: '站内',
      //       value: 1
      //     },
      //     {
      //       label: '穿山甲',
      //       value: 2
      //     }
      //   ]
      // },
      // {
      //   key: 'download_type',
      //   name: '下载方式',
      //   multiple: true,
      //   selected: [],
      //   options: [
      //     {
      //       label: '下载链接',
      //       value: 1
      //     },
      //     {
      //       label: '落地页',
      //       value: 2
      //     }
      //   ]
      // },
      {
        key: 'ad_budget_mode',
        name: $bp_t('计划预算', 'common.ad_budget'),
        multiple: true,
        selected: [],
        options: [
          // {
          //   label: '不限',
          //   value: -1
          // },
          {
            label: $bp_t('按日预算', 'common.daily_budget_one'),
            value: 0
          },
          {
            label: $bp_t('总预算', 'common.general_budget'),
            value: 1
          }
        ]
      },
      { // 用户低质广告筛选功能---!!!!!!!! 注意国际化没有，pm决定暂用机翻---!!!!!!!!注意国际化没有pm决定暂用机翻 ---!!!!!!!
        key: 'audit_suggest',
        name: '审核建议', // $bp_t('审核建议', 'common.audit_suggestion'),
        multiple: true,
        selected: [],
        options: [
          {
            label: '无建议', // $bp_t('无建议', 'common.no_suggestion'), //
            value: 0
          },
          {
            label: '建议修改', // $bp_t('建议修改'), //, 'common.suggestion_amend'
            value: -1,
            children: [
              {
                label: '低俗素材', // $bp_t('低俗素材', 'common.vulgar_material'), //
                value: 2
              },
              {
                label: '引人不适', // $bp_t('引人不适', 'common.cause_discomfort'), //
                value: 3
              },
              {
                label: '素材质量低', // $bp_t('素材质量低', 'common.low_material_quality'), //
                value: 4
              }, {
                label: '夸大宣传', // $bp_t('夸大宣传', 'common.exaggerated_propaganda'), //
                value: 5
              },
              {
                label: '其他', // $bp_t('其他', 'common.other'),
                value: 6
              }
            ]
          },
          {
            label: '审核不通过', // $bp_t('审核不通过', 'common.audit_failed'),
            value: 1
          }
        ]
      }
    ]
    // effect: [
    //   {
    //     type: 'range',
    //     key: 'ad_budget',
    //     name: '计划预算',
    //     selected: {
    //       st: '',
    //       et: '',
    //       unit: ''
    //     }
    //   },
    //   {
    //     type: 'range',
    //     key: 'show_cnt',
    //     // key: 'ad_show_cnt',
    //     name: '计划展示数',
    //     selected: {
    //       st: '',
    //       et: '',
    //       unit: ''
    //     }
    //   },
    //   {
    //     type: 'range',
    //     key: 'click_cnt',
    //     name: '计划点击数',
    //     selected: {
    //       st: '',
    //       et: '',
    //       unit: ''
    //     }
    //   }
    // ]
  },
  creative: {
    normal: [
      {
        key: 'creative_status',
        name: $bp_t('创意状态', 'common.creative_status'),
        multiple: false,
        selected: [],
        options: [
          {
            label: $bp_t('不限', 'common.unlimited'),
            value: 0
          },
          {
            label: $bp_t('投放中', 'common.creative_status_0'),
            value: 14
          },
          {
            label: $bp_t('已暂停', 'common.ad_status_5'),
            value: 6
          },
          {
            label: $bp_t('新建', 'common.newly_build'),
            value: 3
          },
          {
            label: $bp_t('已被广告计划暂停', 'common.suspended_by_ad_plan'),
            value: 7
          },
          {
            label: $bp_t('已被广告组暂停', 'common.ad_status_6'),
            value: 8
          },
          {
            label: $bp_t('广告计划超出预算', 'common.creative_status_42'),
            value: 11
          },
          {
            label: $bp_t('广告组超出预算', 'common.ad_status_7'),
            value: 10
          },
          {
            label: $bp_t('账户余额不足', 'common.ad_status_43'),
            value: 12
          },
          {
            label: $bp_t('修改审核中', 'common.ad_status_3'),
            value: 4
          },
          {
            label: $bp_t('新建审核中', 'common.ad_status_2'),
            value: 16
          },
          {
            label: $bp_t('审核拒绝', 'bp.promotion_audit_reject'),
            value: 17
          },
          {
            label: $bp_t('已删除', 'common.ad_status_4'),
            value: 1
          },
          {
            label: $bp_t('已完成', 'common.ad_status_12'),
            value: 5
          },
          {
            label: $bp_t('不在投放时段', 'common.ad_status_13'),
            value: 15
          },
          {
            label: $bp_t('未达到投放时间', 'common.creative_status_11'),
            value: 9
          },
          {
            label: $bp_t('不限（包含已删除）', 'common.unlimited_including_deleted'),
            value: NoLimitVal
          }

          // {
          //   label: '终止',
          //   value: 2
          // },
          // {
          //   label: '预上线',
          //   value: 13
          // }
        ]
      },
      {
        key: 'image_mode',
        name: $bp_t('素材样式', 'bp.promotion_material_style'),
        multiple: true,
        selected: [],
        options: [
          {
            label: $bp_t('小图', 'common.small_graph'),
            value: 2
          },
          {
            label: $bp_t('大图横图', 'common.horizontal_version'),
            value: 3
          },
          {
            label: $bp_t('竖版大图', 'bp.promotion_vertical_layout'),
            value: 16
          },
          {
            label: $bp_t('组图', 'common.group_diagram'),
            value: 4
          },
          {
            label: $bp_t('横版视频', 'common.horizontal_video'),
            value: 5
          },
          {
            label: $bp_t('竖版视频', 'common.vertical_video'),
            value: 15
          },
          {
            label: '家装联盟卡券',
            value: 188
          },
          {
            label: Splash.Image.text,
            value: Splash.Image.value
          },
          {
            label: $bp_t('直播画面', 'common.live_picture'),
            value: 166
          }
        ]
      },
      {
        key: 'creative_material_mode',
        name: $bp_t('创意方式', 'common.creative_way'),
        multiple: true,
        selected: [],
        options: [
          {
            label: $bp_t('自定义创意', 'common.custom_ideas'),
            value: 2
          },
          {
            label: $bp_t('程序化创意', 'common.procedural_creativity'),
            value: 3
          }
        ]
      }
    ]
  }
}

// 新版 投放场景-竞价策略 支持筛选
// 新版竞价策略需要对历史数据刷库完成后，再放开筛选项
// if (isSupportNewBiddingStrategy) {
//   const options = [
//     {
//       label: $bp_t('常规投放-稳定成本', 'bp.promote_filter_bidding_strategy_option_1'),
//       value: 1
//     },
//     {
//       label: $bp_t('常规投放-控制成本上限', 'bp.promote_filter_bidding_strategy_option_2'),
//       value: 2
//     },
//     isTwoStageWhiteList && {
//       label: $bp_t('常规投放-两阶段跑量', 'bp.promote_filter_bidding_strategy_option_3'),
//       value: 5
//     },
//     {
//       label: $bp_t('放量投放', 'bp.promote_filter_bidding_strategy_option_4'),
//       value: 3
//     },
//     isSupportNoBid && {
//       label: $bp_t('最大转化投放', 'bp.promote_filter_bidding_strategy_option_5'),
//       value: 4
//     }
//   ]
//   filters.ad.normal.push({
//     key: 'bidding_strategy',
//     name: $bp_t('投放场景-竞价策略', 'bp.promote_filter_bidding_strategy'),
//     multiple: true,
//     selected: [],
//     options: options.filter(Boolean)
//   })
// }

// 支持直播间，再添加直播间推广目的筛选项
if (!Tool.isSupported(GLOBAL_VAR.adver_func.promote_blacklist)) {
  checkIsSupportLive().then(isSupport => {
    if (isSupport) {
      filters.campaign.normal.some(selection => {
        if (selection.key === 'landing_type') {
          selection.options.push({
            label: landingType.LIVE.text,
            value: landingType.LIVE.value
          })
          return true
        }
      })
    }
  })
}

// 如果是搜索广告下，需要增加如下内容
if (isSearchAdv) {
  filtersNav.push({
    label: $bp_t('关键词', 'common.keyword'),
    id: 'keyword'
  })
  filters.campaign.normal.push({
    key: 'set_privative',
    name: $bp_t('组否定词', 'common.promotion_filter_campaign_deny_word'),
    multiple: false,
    selected: [],
    options: [
      {
        label: $bp_t('不限', 'common.unlimited'),
        value: NoLimitVal
      },
      {
        label: $bp_t('未设置否定词', 'bp.promotion_filter_no_deny_word'),
        value: 0
      },
      {
        label: $bp_t('已设置否定词', 'bp.promotion_filter_have_deny_word'),
        value: 1
      }
    ]
  },
  {
    key: 'campaign_type',
    name: $bp_t('广告组类型', 'bp.statistics_fields_promotion_ad_group_type'),
    selected: [],
    multiple: true,
    options: [
      {
        label: campaignType.NEWS_FEED.text,
        value: campaignType.NEWS_FEED.value
      },
      {
        label: campaignType.SEARCH_AD.text,
        value: campaignType.SEARCH_AD.value
      }
    ]
  })
  filters.ad.normal.push(
    {
      key: 'privative_source',
      name: $bp_t('计划否定词', 'common.promotion_filter_ad_deny_word'),
      multiple: false,
      selected: [],
      options: [
        {
          label: $bp_t('不限', 'common.unlimited'),
          value: NoLimitVal
        },
        {
          label: $bp_t('未设置否定词', 'bp.promotion_filter_no_deny_word'),
          value: 0
        },
        {
          label: $bp_t('已设置否定词', 'bp.promotion_filter_have_deny_word'),
          value: 1
        }
      ]
    }, {
      key: 'platform',
      name: '平台',
      multiple: false,
      selected: [],
      options: [
        {
          label: '不限',
          value: NoLimitVal
        },
        {
          label: 'IOS',
          value: 2
        },
        {
          label: 'Android',
          value: 1
        },
        {
          label: 'PC',
          value: 16
        }
      ]
    }, {
      key: 'native_type_filter',
      name: '是否使用抖音号',
      multiple: false,
      selected: [],
      options: [
        {
          label: '不限',
          value: NoLimitVal
        },
        {
          label: '使用',
          value: 1
        },
        {
          label: '不使用',
          value: 2
        }
      ]
    })
  filters.creative.normal[1].options.push({
    label: $bp_t('搜索大图', 'common.search_for_larger_maps'),
    value: IMAGEMODE.SEARCH_LARGE_IMAGE
  },
  {
    label: $bp_t('搜索小图', 'common.search_small_graph'),
    value: IMAGEMODE.SEARCH_MINI_IMAGE
  },
  {
    label: $bp_t('搜索橱窗', 'bp.search_shopwindow'),
    value: IMAGEMODE.SEARCH_SHOPWINDOW
  })

  // 关键词质量度， 1分到10分
  const qualityValueList = new Array(10).fill(0).map((item, index) => {
    item = {
      label: `${index + 1}分`,
      value: index + 1
    }
    return item
  })

  filters.keyword = {
    normal: [
      {
        key: 'keyword_status',
        name: $bp_t('关键词状态', 'common.keyword_status'),
        multiple: false,
        selected: [],
        options: [
          {
            label: $bp_t('不限', 'common.unlimited'),
            value: 0
          },
          {
            label: $bp_t('词已删除', 'bp.promotion_filter_word_deleted'),
            value: 1
          },
          {
            label: $bp_t('投放中', 'common.put_in'),
            value: 2
          },
          {
            label: $bp_t('词暂停', 'bp.promotion_filter_suspended'),
            value: 3
          },
          {
            label: $bp_t('词审核不通过', 'bp.promotion_filter_word_audit_failed'),
            value: 4
          },
          {
            label: $bp_t('词新建审核中', 'bp.promotion_filter_word_auditing'),
            value: 5
          },
          {
            label: $bp_t('广告计划已暂停', 'common.creative_status_61'),
            value: 6
          },
          {
            label: $bp_t('广告计划审核不通过', 'common.creative_status_v2_94'),
            value: 7
          },
          {
            label: $bp_t('广告计划新建审核中', 'common.creative_status_v2_92'),
            value: 8
          },
          {
            label: $bp_t('广告计划修改审核中', 'common.creative_status_v2_91'),
            value: 9
          },
          {
            label: $bp_t('广告计划超出预算', 'common.creative_status_42'),
            value: 10
          },
          {
            label: $bp_t('广告计划新建', 'common.creative_status_v2_92'),
            value: 11
          },
          {
            label: $bp_t('广告计划不在投放时段', 'bp.promotion_filter_ad_not_in_put_time'),
            value: 12
          },
          {
            label: $bp_t('广告计划已完成', 'bp.promotion_filter_ad_completed'),
            value: 13
          },
          {
            label: $bp_t('广告组超出预算', 'common.ad_team_over_budget'),
            value: 14
          },
          {
            label: $bp_t('已被广告组暂停', 'common.paused_by_ad_group'),
            value: 15
          },
          {
            label: $bp_t('账户余额不足', 'common.insufficient_account_balance'),
            value: 16
          },
          {
            label: $bp_t('不限（含已删除）', 'common.no_limite_include_deleted'),
            value: NoLimitVal
          }
        ]
      },
      {
        key: 'match_type',
        name: $bp_t('匹配方式', 'common.match_ways'),
        selected: [],
        multiple: true,
        options: [
          {
            label: $bp_t('精确', 'common.accurate'),
            value: 5
          },
          {
            label: $bp_t('短语', 'common.phrase'),
            value: 10
          },
          {
            label: $bp_t('广泛', 'common.widely'),
            value: 20
          }
        ]
      },
      {
        key: 'quality',
        name: $bp_t('质量度', 'common.promotion_quality'),
        selected: [],
        multiple: true,
        options: qualityValueList
      },
      {
        key: 'source',
        name: $bp_t('关键词来源', 'common.promotion_keyword_source'),
        selected: [],
        multiple: false,
        options: [
          {
            label: $bp_t('不限', 'common.unlimited'),
            value: -1
          },
          {
            label: $bp_t('自动加词', 'common.promotion_keyword_auto_added'),
            value: 1
          },
          {
            label: $bp_t('手动加词', 'common.promotion_keyword_manual_added'),
            value: 0
          }
        ]
      }
    ]
  }
}
if (isDeliveryMajordomo) {
  filters.campaign.normal.push({
    key: 'delivery_mode',
    name: $bp_t('投放模式', 'common.delivery_modal'),
    multiple: false,
    selected: [],
    options: [
      {
        label: '不限',
        value: 0
      },
      {
        label: '标准投放',
        value: 1
      },
      {
        label: '管家&省心投放',
        value: 2
      }
    ]
  })
}

// 穿山甲-精选休闲游戏，有白名单逻辑
if (Tool.isSupported(GLOBAL_VAR.union_smart_game_white)) {
  filters.ad.normal.forEach(selection => {
    if (selection.key === PromotionFilterValue.AppCode._key) {
      selection.options.push({
        label: LegalText.common.pangolin_selected_leisure_games,
        value: 27
      })
    }
  })
}

// 穿山甲-开屏视频，有白名单逻辑
if (Tool.isSupported(GLOBAL_VAR.hasUnionSplash)) {
  filters.creative.normal.forEach(selection => {
    if (selection.key === PromotionFilterValue.ImageMode._key) {
      selection.options.push({
        label: Splash.Video.text,
        value: Splash.Video.value
      })
    }
  })
}

// 通投白名单控制筛选项
if (Tool.isSupported(GLOBAL_VAR.adver_func.universal_delivery)) {
  filters.ad.normal.forEach(selection => {
    if (selection.key === PromotionFilterValue.AppCode._key) {
      selection.options.push({
        label: $bp_t('通投智选', 'common.universal_delivery'),
        value: 33
      })
    }
  })
}
// 出价白名单的时候，隐藏投放方式
if (Tool.isSupported(GLOBAL_VAR.adver_func.new_bid_strategy)) {
  let flowControlModeIndex = filters.ad.normal.findIndex(ad => {
    return ad.key === 'flow_control_mode'
  })
  flowControlModeIndex > -1 && filters.ad.normal.splice(flowControlModeIndex, 1)
}
// 白名单逻辑,控制筛选项营销场景筛选项（游戏垂直化、汽车垂直化）
if (GLOBAL_VAR.canGameScenePromotion || (GLOBAL_VAR.verticalIndustryRules && GLOBAL_VAR.verticalIndustryRules.automobile_scene)) {
  let options = [{
    // '不限'
    label: $bp_t('不限', 'common.unlimited'),
    value: NoLimitVal
  }]
  switch (true) {
    case GLOBAL_VAR.canGameScenePromotion:
      options = [
        ...options,
        {
          // '新游大推&日常投放'
          label: marketingScene.GAME_PROMOTION.text,
          value: 2
        },
        {
          // '新游预约'
          label: marketingScene.GAME_SUBSCRIBE.text,
          value: 1
        }
      ]
      break
    case (GLOBAL_VAR.verticalIndustryRules && GLOBAL_VAR.verticalIndustryRules.automobile_scene):
      options = [
        ...options,
        {
          // 汽车线索转化
          label: marketingScene.AUTOMOBILE_CLUE_CONVERSION.text,
          value: 3
        }
      ]
      break
  }
  filters.campaign.normal.push(
    {
      key: 'marketing_scene',
      name: $bp_t('营销场景', 'common.marketing_scene'),
      multiple: false,
      selected: [],
      options
    }
  )
}
function findAutomateRuleProps (item) {
  const {
    findRuleType,
    AdConfig
  } = conditionConfig
  const { RELATION_MAP_THREE } = automateRuleConfig
  const type = findRuleType(item)
  const ruleConfig = AdConfig[type]
  let currentRuleConfig = ruleConfig
  const rangeTypeList = []
  const value = {}
  while (currentRuleConfig) {
    let next
    if (currentRuleConfig.next) {
      next = currentRuleConfig.next[Object.keys(currentRuleConfig.next).find(key => (new RegExp(key).test(currentRuleConfig.defaultNext)))]
    }
    if (currentRuleConfig.promotionSkip) {
      currentRuleConfig = next
      continue
    }
    if (next) {
      Object.values(currentRuleConfig?.props?.optionList || {}).forEach(item => {
        const findValue = Object.values(RELATION_MAP_THREE).find(value => value.value === item.value)
        if (findValue) {
          value[findValue.promotionValue] = ''
          value.field = item.rpcValue
          rangeTypeList.push(findValue.promotionValue)
        }
      })
    } else {
      value.unit = currentRuleConfig.props.unit
    }
    currentRuleConfig = next
  }
  return {
    rangeTypeList,
    value
  }
}

function filtersAddAutoMateRule () {
  const studyStatus = {
    key: 'study_period_status',
    name: '学习期状态',
    multiple: true,
    selected: [],
    options: []
  }
  const diagnosisStatus = {
    key: 'diagnosis_status',
    name: '诊断状态',
    multiple: true,
    selected: [],
    options: []
  }
  const campaignFilters = []
  const adFilters = []
  const creativeFilters = []
  const keywordFilters = []
  Object.values(automateRuleConfig.ALL_SUBJECT_MAP).forEach((item) => {
    if (!item.promotionNeed) {
      return
    }
    if (
      item.parent === automateRuleConfig.SUBJECT_FIRST_LEVEL_MAP.DIAGNOSIS_STATUS ||
      item.parent === automateRuleConfig.SUBJECT_FIRST_LEVEL_MAP.NEW_STATUS
    ) {
      item.promotionKey === studyStatus.key && studyStatus.options.push({
        label: item.label,
        value: +item.value
      })
      item.promotionKey === diagnosisStatus.key && diagnosisStatus.options.push({
        label: item.label,
        value: +item.value
      })
    } else {
      const { value, rangeTypeList } = findAutomateRuleProps(item)
      const filter = {
        submitKey: item.rpcValue,
        name: item.label,
        automateRule: true,
        rangeTypeList,
        value
      }
      const campaignFilter = _.cloneDeep(filter)
      const adFilter = _.cloneDeep(filter)
      const creativeFilter = _.cloneDeep(filter)
      const keywordFilter = _.cloneDeep(filter)
      const filtersNavFilter = [campaignFilter, adFilter, creativeFilter, keywordFilter]
      filtersNav.forEach((item, index) => {
        filtersNavFilter[index].key = `${item.id}_${filtersNavFilter[index].submitKey}`
        filtersNavFilter[index].name = item.label + filtersNavFilter[index].name
        const disabledDisableStr = filtersNav.reduce((all, curr, index) =>
          `${all}${curr.label === item.label
            ? ''
            : ((curr.label === '组' ? '广告组' : curr.label) + '、')}`, '')
        filtersNavFilter[index].disabledText = `该筛选条件不对${
          disabledDisableStr.slice(0, disabledDisableStr.length - 1)
        }列表生效`
        filtersNavFilter[index].parentType = item.id
      })
      // 先只在计划中加入这些指标，如果后面需要再加入解开注释即可
      // campaignFilters.push(campaignFilter)
      adFilters.push(adFilter)
      // creativeFilters.push(creativeFilter)
      // keywordFilters.push(keywordFilter)
    }
  })
  // 自动规则ID筛选，从通知链接中跳转而来，带有规则ID的数组
  const autoruleIdsFilter = {
    key: 'autorule_ids',
    name: '规则 ID',
    multiple: true,
    // 只在推广管理页面上回显，不在计划筛选组件中展示，且不作为筛选参数
    displayOnly: true,
    // 关联 query 中实际用到的参数
    mappedKey: 'notification_id',
    // 当该筛选项被清空时需要同步清除关联的 key
    relatedKeys: ['notification_id', 'diagnosis_origin_from'],
    // 将 query 参数中的值直接作为筛选项的选项
    valueAsOptions: true,
    parentType: 'ad',
    disabledText: '该筛选条件不对广告组、创意、关键词列表生效',
    selected: [],
    options: []
  }
  filters?.ad?.normal?.push(studyStatus)
  filters?.ad?.normal?.push(diagnosisStatus)
  filters?.campaign?.normal?.push(...campaignFilters)
  filters?.ad.normal?.push(...adFilters)
  filters?.ad.normal?.push(autoruleIdsFilter)
  filters?.creative?.normal?.push(...creativeFilters)
  filters?.keyword?.normal?.push(...keywordFilters)
}
filtersAddAutoMateRule()

export const AllFilterKeys = []
export const AllFiltersConfig = {}
Object.keys(filters).forEach((category) => {
  if (filters[category] && filters[category].normal) {
    filters[category].normal.forEach((filter) => {
      const key = filter.key
      AllFilterKeys.push(key)
      AllFiltersConfig[key] = {
        type: filter.type,
        key,
        name: filter.name,
        multiple: filter.multiple,
        options: filter.options,
        selected: [],
        defaultSelected: filter.defaultSelected,
        isMutuallyExclusive: filter.isMutuallyExclusive,
        disabledText: filter.disabledText,
        submitKey: filter.submitKey,
        parentType: filter.parentType,
        valueAsOptions: filter.valueAsOptions,
        displayOnly: filter.displayOnly,
        mappedKey: filter.mappedKey,
        relatedKeys: filter.relatedKeys
      }
      // 购买类型默认竞价
      if (key === 'purchase_type') {
        AllFiltersConfig[key].selected = AllFiltersConfig[key].defaultSelected
      }
    })
  }
})

export const creativeFilterKeys = []
filters.creative.normal.forEach(options => creativeFilterKeys.push(options.key))
export const keywordFilterKeys = []
if (filters.keyword) {
  filters.keyword.normal.forEach(options => keywordFilterKeys.push(options.key))
}
